import { render, staticRenderFns } from "./PvReverse.vue?vue&type=template&id=51dab579&scoped=true&"
import script from "./PvReverse.vue?vue&type=script&lang=js&"
export * from "./PvReverse.vue?vue&type=script&lang=js&"
import style0 from "./PvReverse.vue?vue&type=style&index=0&id=51dab579&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dab579",
  null
  
)

export default component.exports